import { getAccessToken, setAccessToken, clearAccessToken } from "./tokenStorage";
import { refreshAccessToken } from "../api/authApi";

// Check if token is expired or will expire soon (within 5 minutes)
function isTokenExpiringSoon(token) {
    if (!token) return false;

    try {
        const payload = token.split(".")[1];
        const decoded = JSON.parse(atob(payload));
        const exp = decoded.exp * 1000; // Convert to milliseconds
        const now = Date.now();
        const fiveMinutes = 5 * 60 * 1000;

        return exp - now < fiveMinutes;
    } catch (e) {
        console.error("Failed to decode token:", e);
        return false;
    }
}

export async function fetchWithAuth(url, options = {}) {
    let token = getAccessToken();

    // Only try to refresh if we have a token AND it's expiring soon
    if (token && isTokenExpiringSoon(token)) {
        try {
            const authResponse = await refreshAccessToken();
            setAccessToken(authResponse.accessToken);
            token = authResponse.accessToken;
        } catch (refreshError) {
            console.error("Failed to refresh token proactively:", refreshError);
            // Don't throw here, let the request proceed and handle 401/403 below
        }
    }

    const headers = { ...options.headers };
    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    let res = await fetch(url, { ...options, headers, credentials: "include" });

    // If we get 401/403 and have a token, try refreshing once
    if ((res.status === 401 || res.status === 403) && token) {
        try {
            const authResponse = await refreshAccessToken();
            setAccessToken(authResponse.accessToken);

            headers["Authorization"] = `Bearer ${authResponse.accessToken}`;
            res = await fetch(url, { ...options, headers, credentials: "include" });
        } catch (refreshError) {
            clearAccessToken();
            // Don't throw, just return the 401/403 response
        }
    }

    return res;
}
